<div [class]="this.getClass()">
  @if (iconNames() && iconNames().length) {
    @for(icon of iconNames(); track icon) {
      <div>
        <lib-app-icon [icon]="icon" [size]="iconSize() ?? '20x12'" [className]="iconClassName()"/>
      </div>
    }
  } @else if (prefixLabel()) {
    <div class="mat-body-1 z-1 !text-xs">
      <span class="relative">{{prefixLabel()}}</span>
    </div>
  }
  @if(isLoading()) {
    <mat-spinner diameter="16" class="ml-1"></mat-spinner>
  }
  @if(content()) {
    <div [class]="this.getContentStyle()">{{ content() }}</div>
  }
</div>
